<template>
    <div class="p-4 bg-white shadow-md">
        <h2 class="text-xl font-semibold text-gray-800 flex items-center mb-4">
            <span class="text-2xl mr-2">📈</span>
            <span>High School Score Distribution</span>
        </h2>

        <div v-if="hasData">
            <apexchart type="bar" height="400" :options="chartOptions" :series="series" />
        </div>

        <div v-else class="text-gray-500 text-center py-16">
            <div class="text-4xl mb-2">⚠️</div>
            <div>There is no data to show</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "HighSchoolGpaBucketByGender",
    props: {
        data: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            series: [
                {
                    name: 'Male',
                    data: [],
                },
                {
                    name: 'Female',
                    data: [],
                },
            ],
            chartOptions: {
                chart: {
                    type: 'bar',
                    stacked: true,
                    toolbar: { show: false },
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight: '60%',
                        dataLabels: {
                            total: {
                                enabled: true,
                                offsetX: 0,
                                style: {
                                    fontSize: '13px',
                                    fontWeight: 900
                                }
                            }
                        }
                    },
                },
                dataLabels: {
                    enabled: true,
                    offsetX: 0,
                    style: {
                        fontSize: '10px',
                        fontWeight: 900
                    }
                },
                stroke: {
                    width: 1,
                    colors: ['#fff']
                },
                xaxis: {
                    categories: [],
                    title: {
                        text: 'Number of Students',
                        style: {
                            fontSize: '12px',
                            fontWeight: 'bold',
                        },
                    },
                },
                yaxis: {
                    title: {
                        text: "Score(%)",
                    },
                },
                colors: ['#4C78A8', '#F58518'],
                legend: {
                    position: 'top',
                    horizontalAlign: 'right',
                    labels: {
                        colors: '#4A5568',
                    },
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                },
            },
        };
    },
    computed: {
        hasData() {
            return (
                this.series &&
                this.series.length &&
                this.series.some(s => Array.isArray(s.data) && s.data.some(val => val > 0))
            );
        },
    },
    watch: {
        data: {
            handler(newData) {
                if (!Array.isArray(newData) || newData.length === 0) {
                    this.series = [];
                    return;
                }

                const categories = newData.map(item => item.gpa_bucket);
                const maleData = newData.map(item => item.male_count);
                const femaleData = newData.map(item => item.female_count);

                this.chartOptions = {
                    ...this.chartOptions,
                    xaxis: {
                        ...this.chartOptions.xaxis,
                        categories,
                    },
                };

                this.series = [
                    {
                        name: 'Male',
                        data: maleData,
                    },
                    {
                        name: 'Female',
                        data: femaleData,
                    },
                ];
            },
            immediate: true,
        },
    },
};
</script>
